import { connect } from 'react-redux'

import { doFetchJiraServerIssues } from 'ducks/integrations/jiraServer'
import {
  selectCurrentTicketLinkedIssues,
  selectJiraSites,
} from 'ducks/integrations/jiraShared'

import LinkedJiraServerIssues from './view'

const select = state => {
  return {
    issues: selectCurrentTicketLinkedIssues(state, {
      provider: 'jira_server',
      source: 'jiraServer',
    }),
    sites: selectJiraSites(state, { source: 'jiraServer' }),
  }
}

const perform = {
  doFetchJiraServerIssues,
}

export default connect(select, perform)(LinkedJiraServerIssues)
